<!-- «Liquidación al comercio» (EST-01/02; maqueta escenario 4). Solo con liquidacion.consultar (EST-08). -->
<section class="kb-card" *ngIf="puede && code">
  <div class="kb-card-header flex-wrap gap-3">
    <h2 class="kb-card-title flex items-center gap-2"><i class="fas fa-hand-holding-usd text-muted-foreground" aria-hidden="true"></i>Liquidación al comercio</h2>
    <span class="kb-badge shrink-0" *ngIf="m" [ngClass]="claseMarca(m.estado)">{{ m.texto }}</span>
  </div>
  <div class="kb-card-body">
    <p class="kb-hint m-0" *ngIf="cargando">Leyendo la liquidación…</p>
    <p class="kb-hint m-0" *ngIf="error">{{ error }}</p>
    <ng-container *ngIf="m">
      <p class="m-0 text-sm text-foreground" *ngIf="m.modelo !== 'COBRANZA' && linea">{{ linea }}.</p>
      <p class="m-0 text-sm text-foreground" *ngIf="m.modelo === 'COBRANZA'">
        Liquidada {{ m.pct_liquidado || 0 }} % · {{ m.cuotas_liquidadas }} de {{ m.n_cuotas }} cuotas ·
        pagado {{ (m.totales?.pagado || 0) | number:'1.2-2':'es' }} · en el cierre {{ (m.totales?.en_cierre || 0) | number:'1.2-2':'es' }} ·
        por cobrar {{ (m.totales?.por_cobrar || 0) | number:'1.2-2':'es' }} de {{ (m.totales?.credito || 0) | number:'1.2-2':'es' }}.
        <span class="kb-hint block mt-1">En cobranza el crédito está 100 % liquidado solo cuando todas sus cuotas se cobraron y se liquidaron.</span>
      </p>
      <a class="mt-3 inline-block text-sm font-medium text-foreground underline underline-offset-2"
         [routerLink]="['/console/liquidacion/consultas']" [queryParams]="{ vista: 'buscar', venta: code }">Ver la traza completa →</a>
    </ng-container>
  </div>
</section>
